/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticleTeaserDefault from 'base/components/standalone/ArticleTeaser/Default';

export const DynamicStandaloneArticleTeaserDefault = StandaloneArticleTeaserDefault;
export type DynamicStandaloneArticleTeaserDefaultProps = PropsFromComponent<typeof StandaloneArticleTeaserDefault>;

export const DynamicStandaloneArticleTeaserDefaultWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticleTeaserDefault => {
    return function DynamicStandaloneArticleTeaserDefault(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleTeaserDefault');
        return <StandaloneArticleTeaserDefault {...mergeProps({ options: { theme } }, props)} />;
    }
}